export class EventsAndDates {
  diseaseProgression!: DiseaseProgression[];
  relapse!: Relapse[];
  palliativeCare!: PalliativeCare[];
  death!: Death

  constructor() {
    this.diseaseProgression = [];
    this.relapse = [];
    this.palliativeCare = [];
    this.death = new Death();
  }
}

export class DiseaseProgression {
  id!: string;
  diseaseProgressionDate!: Date | null;
  diseaseProgressionType!: string;
  diseaseProgressionLocations!: string[];
  diseaseProgressionCreatedDate!: Date | null;

  constructor() {
    this.id = '';
    this.diseaseProgressionDate = null;
    this.diseaseProgressionLocations = [];
    this.diseaseProgressionCreatedDate = null;
    this.diseaseProgressionType = '';
  }

  setDiseaseProgression(disease: any, locations: string[]) {
    let newDisease: DiseaseProgression = new DiseaseProgression();

    newDisease.diseaseProgressionCreatedDate = new Date();
    newDisease.diseaseProgressionDate = disease.diseaseProgressionDate;
    newDisease.diseaseProgressionLocations = locations;
    newDisease.diseaseProgressionType = disease.diseaseProgressionType ?? '';
    newDisease.id = disease.id ?? '';

    return newDisease;
  }
}

export class Relapse {
  id!: string;
  relapseCreatedDate!: Date | null;
  relapseDate!: Date | null;
  relapseType!: string;
  relapseLocations: string[];

  constructor() {
    this.id = '';
    this.relapseCreatedDate = null;
    this.relapseDate = null;
    this.relapseType = '';
    this.relapseLocations = [];
  }

  setRelapse(relapse: any, locations: string[]) {
    let newRelapse: Relapse = new Relapse;

    newRelapse.relapseCreatedDate = new Date();
    newRelapse.relapseDate = relapse.relapseDate;
    newRelapse.relapseLocations = locations;
    newRelapse.relapseType = relapse.relapseType ?? '';
    newRelapse.id = relapse.relapseId ?? '';

    return newRelapse;
  }
}

export class PalliativeCare {
  id!: string;
  palliativeCareDate!: Date | null;
  palliativeCareCreatedDate!: Date | null;

  constructor() {
    this.id = '';
    this.palliativeCareDate = null;
    this.palliativeCareCreatedDate = null;
  }
}

export class Death {
  id!: string;
  deathCreatedDate!: Date | null;
  deathDate!: Date | null;
  deathDiseaseRelated!: string;
  deathLocations!: string;

  constructor() {
    this.id = '';
    this.deathCreatedDate = null;
    this.deathDate = null;
    this.deathDiseaseRelated = '';
    this.deathLocations = '';
  }
}
